import esES from "./es-ES";
export default {
  "es-ES": esES
};


//////////////////
// WEBPACK FOOTER
// ./~/d3plus-common/es/src/locales/index.js
// module id = 6YHD
// module chunks = 0